import { useRouter } from '@/i18n/routing';
import useCartStore from '@/stores/cart/store';
import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { Button } from '@/components/design-system/index';
import { useFeaturedProducts } from '@/stores/featuredProducts/store';
import useSession from '../../stores/session/useSession';

interface Props {
  product: SearchProduct;
}

const FeaturedEcommerceButton: FC<Props> = (props) => {
  const t = useTranslations('common');
  const { user } = useSession();
  const router = useRouter();
  const cart = useCartStore((state) => state);
  const { setFeaturedProducts } = useFeaturedProducts();

  const onClick = () => {
    if (!confirm(t('FeaturedEcommerceButton.ConfirmText'))) {
      return;
    }

    cart.emptyCart();

    setFeaturedProducts([
      {
        product: props.product,
        quantity: 1,
      },
    ]);

    if (!user) {
      router.push({ pathname: '/auth/signin', query: { source: 'checkout' } });
    } else {
      goToCheckout();
    }
  };

  const goToCheckout = () => {
    router.push(`/checkout`);
  };

  return (
    <Button onClick={onClick} id="add_to_cart_button" size="lg" variant="block">
      {t('FeaturedEcommerceButton.OrderNow')}
    </Button>
  );
};

export default FeaturedEcommerceButton;
